import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@airia/ui';
import { LoadingSpinner } from '../../ui/loading-spinner';
import { useOAuthIntegrations } from '../../hooks/useOAuthIntegrations';
import { useOAuthMutations } from '../../hooks/useOAuthMutations';
const OAuthConnectWidget = ({ onConnectionSuccess }) => {
    const { integrations, loading, error, refreshIntegrations, hasOAuthRequirements } = useOAuthIntegrations();
    const { connectToProvider, connectionStates } = useOAuthMutations();
    const handleConnect = async (integration) => {
        try {
            // Use the correct integration ID from the integration data
            const integrationId = integration.integration?.toolId || integration.id;
            await connectToProvider(integration.provider, integration.credentialType, integrationId, integration.integration?.userCredentialConnectorId);
            // Add a delay to allow credential to propagate in the system
            setTimeout(() => {
                refreshIntegrations();
                onConnectionSuccess?.();
            }, 2000); // Wait 2 seconds
        }
        catch (error) {
            console.error(`Failed to connect to ${integration.provider}:`, error);
        }
    };
    // Don't render if no OAuth requirements
    if (!hasOAuthRequirements || loading) {
        return null;
    }
    if (error) {
        return (_jsx("div", { className: "p-4 bg-red-50 border border-red-200 rounded-lg", children: _jsxs("p", { className: "text-sm text-red-600", children: ["Failed to load integrations: ", error] }) }));
    }
    const unconnectedIntegrations = integrations.filter((integration) => !integration.isConnected);
    if (unconnectedIntegrations.length === 0) {
        return null;
    }
    return (_jsxs("div", { className: "p-4 bg-blue-50 border border-blue-200 rounded-lg", children: [_jsxs("div", { className: "mb-3", children: [_jsx("h3", { className: "text-sm font-medium text-blue-900", children: "Third-party App Access Required" }), _jsx("p", { className: "text-xs text-blue-700 mt-1", children: "This agent can connect to the following apps to provide enhanced functionality:" })] }), _jsx("div", { className: "space-y-2", children: unconnectedIntegrations.map((integration) => (_jsxs("div", { className: "flex items-center justify-between", children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx("div", { className: "w-2 h-2 bg-orange-400 rounded-full" }), _jsx("span", { className: "text-sm font-medium text-gray-900", children: integration.name })] }), _jsx(Button, { size: "sm", onClick: () => handleConnect(integration), disabled: connectionStates[integration.id], className: "min-w-[80px]", children: connectionStates[integration.id] ? (_jsx(LoadingSpinner, { className: "w-4 h-4" })) : ('Connect') })] }, integration.id))) }), _jsx("div", { className: "mt-3", children: _jsx("p", { className: "text-xs text-blue-600", children: "You can use the agent without connecting, but some features may be limited." }) })] }));
};
export default OAuthConnectWidget;
